export const environment = {
  production: false,
  dataSource: 'api' as 'mock' | 'api',
  apiBaseUrl: 'https://api-collector.mercureit.com',
  supersetEmbedUrl: 'https://reporting-dev.mercure-collect.local',
};
